<template>
  <div v-html="applyResult"></div>
</template>

<script>
export default {
  name: "form-pay",
  props: {
    applyResult: {
      type: String,
      default: ''
    }
  },
  mounted() {
    console.log(this.applyResult)
    document.write(this.applyResult)
  }
}
</script>
